import { render, staticRenderFns } from "./loaditem.vue?vue&type=template&id=165f13da&scoped=true"
import script from "./loaditem.vue?vue&type=script&lang=js"
export * from "./loaditem.vue?vue&type=script&lang=js"
import style0 from "./loaditem.vue?vue&type=style&index=0&id=165f13da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f13da",
  null
  
)

export default component.exports